import React from "react";

const FAQ = ({ commonData, clientData, faqToggleClick }) => (
  <div
    className="client-resources p-4"
    id={clientData.fAQSlug ? clientData.fAQSlug : commonData.fAQSlug}
  >
    <div className="section-title">{commonData.fAQSectionHeading}</div>
    <div className="faq-area">
      <div className="faq-box pre-arrival">
        <div className="faq-head bggreen">{commonData.fAQHeading}</div>
        <div className="accordion-list">
          {clientData.clientFAQContent &&
          clientData.clientFAQContent.length !== 0
            ? clientData?.clientFAQContent?.map(function (acc, index) {
                return (
                  <div key={index} className="acc-box">
                    <div className="acc-head" onClick={faqToggleClick}>
                      {acc.heading}
                    </div>
                    <div
                      className="acc-cont"
                      dangerouslySetInnerHTML={{ __html: acc.headingContent }}
                    ></div>
                  </div>
                );
              })
            : commonData?.commonFAQContent?.map(function (acc, index) {
                return (
                  <div key={index} className="acc-box">
                    <div className="acc-head" onClick={faqToggleClick}>
                      {acc.heading}
                    </div>
                    <div
                      className="acc-cont"
                      dangerouslySetInnerHTML={{ __html: acc.headingContent }}
                    ></div>
                  </div>
                );
              })}
        </div>
      </div>

      <div className="faq-box information-for-you">
        <div className="faq-head bggreen">{commonData.commonForYouHeading}</div>
        <div className="accordion-list">
          {clientData.clientForYouContent &&
          clientData.clientForYouContent.length !== 0
            ? clientData?.clientForYouContent?.map(function (acc, index) {
                return (
                  <div key={index} className="acc-box">
                    <div
                      className="acc-head underline"
                      onClick={faqToggleClick}
                    >
                      {acc.heading}
                    </div>
                    {acc.headingContent && (
                      <div
                        className="acc-cont"
                        dangerouslySetInnerHTML={{ __html: acc.headingContent }}
                      ></div>
                    )}

                    {acc.contentFiles && (
                      <div className="acc-cont acc-files">
                        <a
                          href={acc.contentFiles._url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="file-link"
                        >
                          {acc.contentIcon !== null ? (
                            <span className="content-icon">
                              <img
                                src={acc.contentIcon._url}
                                alt={acc.contentFiles.name}
                              />
                            </span>
                          ) : (
                            <span className="content-icon">
                              <img
                                src={commonData.commonFileImage._url}
                                alt={commonData.commonFileImage.name}
                              />
                            </span>
                          )}
                        </a>
                      </div>
                    )}
                  </div>
                );
              })
            : commonData?.commonForYouContent?.map(function (acc, index) {
                return (
                  <div key={index} className="acc-box">
                    <div
                      className="acc-head underline"
                      onClick={faqToggleClick}
                    >
                      {acc.heading}
                    </div>
                    <div
                      className="acc-cont"
                      dangerouslySetInnerHTML={{ __html: acc.headingContent }}
                    ></div>
                    <div className="acc-cont acc-files">
                      {acc.contentFiles && (
                        <a
                          href={acc.contentFiles._url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="file-link"
                        >
                          {acc.contentIcon !== null ? (
                            <span className="content-icon">
                              <img
                                src={acc.contentIcon._url}
                                alt={acc.contentFiles.name}
                              />
                            </span>
                          ) : (
                            <span className="content-icon">
                              <img
                                src={commonData.commonFileImage._url}
                                alt={commonData.commonFileImage.name}
                              />
                            </span>
                          )}
                        </a>
                      )}
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  </div>
);

export default FAQ;
